import S from "react";
import { q as _ } from "./index.CVakAlTX.js";
import A from "swr";
import { API_BASE_LANG as L, API_BASE_URL as g } from "../constants/requests/index.js";
import { f as P } from "./fetcher.CPHInLJD.js";
import { f as i } from "./serializers.ClvJp8_D.js";
import { u as E } from "./use-sitecore-context.C7g4vcbm.js";
import { a as I } from "./use-suggest-location-name.bFv45epg.js";
const d = "10", O = "1", p = "search", h = `locations/${p}`, Y = ({
  ...t
} = {}) => {
  var r, o, a;
  const { sitecoreContext: s } = E(), n = (r = s == null ? void 0 : s.route) != null && r.itemId ? `{${(o = s == null ? void 0 : s.route) == null ? void 0 : o.itemId}}` : "", c = ((a = s == null ? void 0 : s.site) == null ? void 0 : a.name) ?? "", f = (s == null ? void 0 : s.language) ?? L, [e, l] = S.useState({ ...t }), m = {
    pageId: n,
    sc_lang: f,
    sc_site: c,
    display: t.display ?? d,
    page: (t == null ? void 0 : t.page) ?? I,
    ...e,
    filters: e.filters ? i(e.filters) : t.filters ? i(t.filters) : void 0
  }, u = _.stringify(m);
  return {
    ...A(
      Object.keys(e).length > 0 ? `${g}${h}?${u}` : null,
      P,
      { revalidateOnFocus: !0 }
    ),
    setLocationSearchParameter: l,
    locationSearchParameter: e
  };
};
export {
  h as A,
  d as S,
  O as a,
  p as b,
  Y as u
};
